<template>
	<v-dialog
		v-model="dialog"
		width="500"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				color="green lighten-2"
				dark
				v-bind="attrs"
				v-on="on"
			>
				<slot name="btn-title"></slot>
			</v-btn>
		</template>

		<v-card>


			<v-card-text>
				<v-row>
					<v-col
						v-for="img in images"
						:key="img"
						class="d-flex child-flex"
						cols="4"
					>
						<v-img
							:src="img"
							:lazy-src="img"
							aspect-ratio="1"
							class="grey lighten-2"
						>
							<template v-slot:placeholder>
								<v-row
									class="fill-height ma-0"
									align="center"
									justify="center"
								>
									<v-progress-circular
										indeterminate
										color="grey lighten-5"
									></v-progress-circular>
								</v-row>
							</template>
						</v-img>
					</v-col>
				</v-row>
			</v-card-text>


		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "gallery-dialog",
		props: {images: Array},
		data() {
			return {
				dialog: false,
			};
		},
	};
</script>

<style scoped>

</style>